export const rubros = [
		
	{
			"nombre": "Normatividad",
			"icono": "Normatividad.png",
			"formatos": [
				{
					"nombre": "Marco Normativo",
					"xlsx": "f01",
					"html": "f01"
				},
			],

		}, 
		{
			
			"nombre": "Estructura",
			"icono":"Estructura.png",
			"formatos": [
				{
					"nombre": "Estructura Orgánica",
					"xlsx": "f02a",
					"html": "f02a"
				},
				{
					"nombre": "Organigrama",
					"xlsx": "f02b",
					"html": "f02b"
				}
			]
		},
		{
			
			"nombre": "Facultades",
			"icono":"Facultades.png",
			"formatos": [
				{
					"nombre": "Facultades",
					"xlsx": "f03",
					"html": "f03"
				},
			]
		},
		{
			
			"nombre": "Programas Operativos Anuales",
			"icono":"ProgramasOperativosAnuales.png",
			"formatos": [
				{
					"nombre": "Metas y Objetivos",
					"xlsx": "f04",
					"html": "f04"
				}
			]
			
		},
		{
			
			"nombre": "Indicadores de Interés",
			"icono":"IndicadoresInteres.png",
			"formatos": [
				{
					"nombre": "Indicadores de Interés",
					"xlsx": "f05",
					"html": "f05"
				}
			]
			
		},
		{
			
			"nombre": "Matriz de Indicadores",
			"icono":"MatrizIndicadores.png",
			"formatos": [
				{
					"nombre": "Matriz de Indicadores",
					"xlsx": "f06",
					"html": "f06"
				}
			]
			
		},
		{
			
			"nombre": "Directorio",
			"icono":"Directorio.png",
			"formatos": [
				{
					"nombre": "Directorio",
					"xlsx": "f07",
					"html": "f07"
				}
			]
			
		},
		{
			
			"nombre": "Sueldos",
			"icono":"Sueldos.png",
			"formatos": [
				{
					"nombre": "Remuneraciones",
					"xlsx": "f08",
					"html": "f08"
				}
			],
			"url" : "https://oficialiamayor.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/8.%20Sueldos"			
		},
		{
			
			"nombre": "Viáticos",
			"icono":"Viaticos.png",
			"formatos": [
				{
					"nombre": "Viáticos",
					"xlsx": "f09",
					"html": "f09"
				}
			]
		},
		{
			
			"nombre": "Plazas",
			"icono":"Plazas.png","formatos": [
				{
					"nombre": "Total de Personal de Base y Confianza",
					"xlsx": "f10",
					"html": "f10"
				},
				{
					"nombre": "Total de las Plazas de Base y Confianza",
					"xlsx": "f10",
					"html": "f10"
				}
			],
			"url" : "https://oficialiamayor.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/10.%20Plazas"	
		},

		{
			
			"nombre": "Honorarios",
			"icono":"Honorarios.png",
			"formatos": [
				{
					"nombre": "Personal de Honorarios",
					"xlsx": "f11",
					"html": "f11"
				}
			]
		},
		{
			"nombre": "Declaraciones Públicas",
			"icono":"DeclaracionesPublicas.png",
			"formatos": [
				{
					"nombre": "Declaraciones Patrimoniales",
					"xlsx": "f12",
					"html": "f12"
				}
			],
			"url" : "https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/12.%20Declaraciones%20P%C3%BAblicas"	
		},


		{
			"nombre": "Datos de Contacto de la Unidad",
			"icono":"DatosContactoUnidad.png",
			"formatos": [
				{
					"nombre": "Domicilio de la Unidad de Transparencia",
					"xlsx": "f13",
					"html": "f13"
				}
			],
			"url" : "https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/13.%20Datos%20de%20Contacto%20de%20la%20Unidad"
		},
	
		{
			
			"nombre": "Convocatorias",
			"icono":"Convocatorias.png",
			"formatos": [
				{
					"nombre": "Convocatorias a Concursos para Cargos Públicos",
					"xlsx": "f14",
					"html": "f14"
				}
			],
		"url" : "https://oficialiamayor.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/14.%20Convocatorias"
		},
		{
			
			"nombre": "Programas Sociales",
			"icono":"ProgramasSociales.png",
			"formatos": [
				{
					"nombre": "Programas de Subsidio, Estimulo y Apoyo",
					"xlsx": "f15a",
					"html": "f15a"
				},
				{
					"nombre": "Padrón de beneficiarios",
					"xlsx": "f15b",
					"html": "f15b"
				}
			],
			"url" : "https://sebiso.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/15%20-%20Programas%20Sociales"
		},
		{
			
			"nombre": "Relaciones Laborales",
			"icono":"RelacionesLaborales.png",
			"formatos": [
				{
					"nombre": "Condiciones Generales de Trabajo",
					"xlsx": "f16a",
					"html": "f16a"
				},
				{
					"nombre": "Recursos Públicos",
					"xlsx": "f16b",
					"html": "f16b"
				}
			],
			"url" : "https://oficialiamayor.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/16.%20Relaciones%20Laborales"
		},
		{
			
			"nombre": "Información Curricular",
			"icono":"InformacionCurricular.png",
			"formatos": [
				{
					"nombre": "Información Curricular",
					"xlsx": "f17",
					"html": "f17"
				}
			]
		},
		{
			
			"nombre": "Sanciones Administrativas",
			"icono":"SancionesAdministrativas.png",
			"formatos": [
				{
					"nombre": "Servidores Públicos Sancionados",
					"xlsx": "f18",
					"html": "f18"
				}
			],
			"url" : "https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/18.%20Sanciones%20Administrativas"	
		},

		{
			
			"nombre": "Servicios",
			"icono":"Servicios.png",
			"formatos": [
				{
					"nombre": "Servicios",
					"xlsx": "f19",
					"html": "f19"
				}
			]
			
		},
		{
			
			"nombre": "Trámites",
			"icono":"Tramites.png",
			"formatos": [
				{
					"nombre": "Trámites",
					"xlsx": "f20",
					"html": "f20"
				}
			]
			
		},
		{
			
			"nombre": "Presupuesto e Informes Trimestrales",
			"icono":"PresupuestoInformesTrimestrales.png",
			"formatos": [
				{
					"nombre": "Presupuesto Anual",
					"xlsx": "f21_a",
					"html": "f21_a"
				},
				{
					"nombre": "Gasto Trimestral",
					"xlsx": "f21_b",
					"html": "f21_b"
				},
				{
					"nombre": "Cuenta Pública",
					"xlsx": "f21_c",
					"html": "f21_c"
				}
			],
			"url" : "https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/21.Presupuesto%20e%20Informes%20Trimestrales"	
			
		},
		{
			
			"nombre": "Deuda Pública",
			"icono":"DeudaPublica.png",
			"formatos": [
				{
					"nombre": "Deuda Pública",
					"xlsx": "f22",
					"html": "f22"
				}
			],
			"url" : "https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/22.Deuda%20P%C3%BAblica"		
		},
		{
			
			"nombre": "Comunicación Social y Publicidad",
			"icono":"ComunicacionSocialPublicidad.png",
			"formatos": [
				{
					"nombre": "Programa Anual de Comunicación Social",
					"xlsx": "f23a",
					"html": "f23a"
				},
				{
					"nombre": "Erogación de Recursos de Comunicación Social",
					"xlsx": "f23b",
					"html": "f23b"
				},
			

				{
					"nombre": "Tiempos Oficiales",
					"xlsx": "f23_c",
					"html": "f23c",
					"xlsx_liga": "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/RadioTVH/dir1/FC/a69_f23_c_RTH.htm",
					"htm_liga": "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/RadioTVH/dir1/FC/a69_f23_c_RTH.xlsx"
				},

				
			]

		},
		{
			
			"nombre": "Resultados de Auditorías",
			"icono":"ResultadosAuditorias.png",
			"formatos": [
				{
					"nombre": "Auditorías",
					"xlsx": "f24",
					"html": "f24"
				}
			],
			"url" : "https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/24.%20Resultados%20de%20Auditor%C3%ADas"	
		},
		{
			
			"nombre": "Dictámines de Estados Financiero ",
			"icono":"DictamenesFinancieros.png",
			"formatos": [
				{
					"nombre": "Estados Financieros",
					"xlsx": "f25",
					"html": "f25"
				}
			],
			"url" : "https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/25.Dict%C3%A1menes%20de%20Estados%20Financieros"	
			
		},
		{
			
			"nombre": "Asignación de Recursos Públicos a Personas",
			"icono":"AsignacionRecursosPublicosPersonas.png",
			"formatos": [
				{
					"nombre": "Personas a Quienes se asignó Recursos Públicos",
					"xlsx": "f26",
					"html": "f26"
				}
			],
			
			
		},
		{
			
			"nombre": "Concesiones",
			"icono":"Concesiones.png",
			"formatos": [
				{
					"nombre": "Concesiones, Contratos, Convenios, Permisos, Licencias y Autorizaciones",
					"xlsx": "f27",
					"html": "f27"
				}
			]
			
		},
		{
			
			"nombre": "Licitaciones Públicas",
			"icono":"LicitacionesPublicas.png",
			"formatos": [
				{
					"nombre": "Procedimientos de Licitación Pública e Invitación a Cuando Menos Tres Personas",
					"xlsx": "f28",
					"html": "f28"
				},

			]
			
		},
		{
			
			"nombre": "Informes",
			"icono":"Informes.png",
			"formatos": [
				{
					"nombre": "Informes",
					"xlsx": "f29",
					"html": "f29"
				}
			],
			"url" : "https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/29.%20Informes"	

			
		},
		{
			
			"nombre": "Estadísticas Generadas",
			"icono":"EstadisticasGenerales.png",
			"formatos": [
				{
					"nombre": "Estadísticas",
					"xlsx": "f30",
					"html": "f30"
				}
			]
			
		},
		{
			
			"nombre": "Informe de Avances y Documentos Financiero",
			"icono":"InformeAvancesDocumentosFinancieros.png",
			"formatos": [
				{
					"nombre": "Informe de Estados Financieros",
					"xlsx": "f31_a",
					"html": "f31_a"
				},
				{
					"nombre": "Informe Contable, Presupuestal y Programático",
					"xlsx": "f31_b",
					"html": "f31_b"
				}
			],
			"url" : "https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/31.Informe%20de%20Avances%20y%20Documentos%20Financieros"
			
		},
		{
			
			"nombre": "Padrón de Proveedores y Contratistas",
			"icono":"PadronProveedoresContratistas.png",
			"formatos": [
				{
					"nombre": "Padrón de Proveedores y Contratistas",
					"xlsx": "f32",
					"html": "f32"
				}
			],
			"url" : "https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/32.%20Padr%C3%B3n%20de%20Proveedores%20y%20Contratistas"
			
		},
		{
			
			"nombre": "Convenios con Sectores Social y Privado",
			"icono":"ConveniosSectoresSocialPrivado.png",
			"formatos": [
				{
					"nombre": "Convenios de Coordinación y Concertación",
					"xlsx": "f33",
					"html": "f33"
				}
			]
			
		},
		{
			
			"nombre": "Inventario de Bienes",
			"icono":"InventarioBienes.png",
			"formatos": [
				{
					"nombre": "Inventario de Bienes Muebles",
					"xlsx": "f34_a",
					"html": "f34_a"
				},
				{
					"nombre": "Alta de Bienes Muebles",
					"xlsx": "f34_b",
					"html": "f34_b"
				},
				{
					"nombre": "Bajas de Bienes Muebles",
					"xlsx": "f34_c",
					"html": "f34_c"
				},
				{
					"nombre": "Inventario de Bienes Inmuebles",
					"xlsx": "f34_d",
					"html": "f34_d"
				},
				{
					"nombre": "Alta de Bienes Inmuebles",
					"xlsx": "f34_e",
					"html": "f34_e"
				},
				{
					"nombre": "Bajas de Bienes Inmuebles",
					"xlsx": "f34_f",
					"html": "f34_f"
				},
				{
					"nombre": "Donaciones de Bienes Muebles e Inmuebles",
					"xlsx": "f34_g",
					"html": "f34_g"
				}

			],
			"url" : "https://oficialiamayor.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/34.%20Inventario%20de%20Bienes"
			
		},
		{
			
			"nombre": "Recomendaciones y Atención en Materia de Derechos Humanos",
			"icono":"RecomendacionesAtenciónMateriaDerechosHumanos.png",
			"formatos": [
				{
					"nombre": "Recomendaciones jde Derechos Humanos Emitidas por la CNDH",
					"xlsx": "f35a",
					"html": "f35a"
				},
				{
					"nombre": "Recomendaciones de Derechos Humanos Casos Especiales",
					"xlsx": "f35b",
					"html": "f35b"
				},
				{
					"nombre": "Las Recomendaciones de Derechos Humanos Org. Int. CNDH",
					"xlsx": "f35c",
					"html": "f35c"
				},
			]
			
		},
		{
			
			"nombre": "Resoluciones y Laudos de Juicios",
			"icono":"ResolucionesLaudosJuicios.png",
			"formatos": [
				{
					"nombre": "Resoluciones y Laudos ",
					"xlsx": "f36",
					"html": "f36"
				}
			],
			"url" : "https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/36.%20Resoluciones%20y%20Laudos%20de%20Juicios"
			
		},
		{
			
			"nombre": "Mecanismo de Participación Ciudadana",
			"icono":"MecanismosParticipacionCiudadana.png",
			"formatos": [
				{
					"nombre": "Mecanismos de Participación Ciudadana",
					"xlsx": "f37a",
					"html": "f37a"
				},
				{
					"nombre": "Resultados de los Mecanismos de Participación Ciudadana",
					"xlsx": "f37b",
					"html": "f37b"
				}
			]
			
		},
		{
			
			"nombre": "Programas Ofrecidos",
			"icono":"ProgramasOfrecidos.png",
			"formatos": [
				{
					"nombre": "Programas que Ofrecen",
					"xlsx": "f38a",
					"html": "f38a"
				},
				{
					"nombre": "Tramites a los Programas que Ofrecen",
					"xlsx": "f38b",
					"html": "f38b"
				}
			]
			
		},
		{
			
			"nombre": "Actas y Resoluciones del Comité de Transparencia",
			"icono":"ActasResolucionesComiteTransparencia.png",
			"formatos": [
				{
					"nombre": "Informe de Sesiones",
					"xlsx": "f39_a",
					"html": "f39_a"
				},
				{
					"nombre": "Informe de Resoluciones",
					"xlsx": "f39_b",
					"html": "f39_b"
				},
				{
					"nombre": "Actas Integrantes del Comité",
					"xlsx": "f39_c",
					"html": "f39_c"
				},
				{
					"nombre": "Calendario de Sesiones del comité",
					"xlsx": "f39_d",
					"html": "f39_d"
				}
			],
			"url" : "https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/39.%20Actas%20y%20Resoluciones%20del%20Comit%C3%A9%20de%20Transparencia"
			
		},
		{
			
			"nombre": "Evaluacion y Encuesta a Programas Financiados con Recursos Públicos",
			"icono":"EvaluacionencuestasProgramas.png",
			"formatos": [
				{
					"nombre": "Evaluaciones",
					"xlsx": "f40_a",
					"html": "f40_a"
				},
				{
					"nombre": "Encuestas",
					"xlsx": "f40_b",
					"html": "f40_b"
				}
			],
			"url" : "https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/40.Evaluacion%20y%20Encuestas%20a%20Programas%20Financiados%20con%20Recursos%20P%C3%BAblicos"	
			
		},
		{
			
			"nombre": "Estudios Pagados con Recursos Públcos",
			"icono":"EstudiosPagadosRecursosPublicos.png",
			"formatos": [
				{
					"nombre": "Estudios Pagados con Recursos Públicos ",
					"xlsx": "f41",
					"html": "f41"
				}
			]
			
		},
		{
			
			"nombre": "Listados Jubilados y Pensionados",
			"icono":"ListadoJubiladosPencionados.png",
			"formatos": [
				{
					"nombre": "Jubilados y Pensionados Leyenda",
					"xlsx": "f42_a",
					"html": "f42_a"
				},
				{
					"nombre": "Jubilados y Pensionados Listado",
					"xlsx": "f42_b",
					"html": "f42_b"
				}
			],
			"url" :  "https://oficialiamayor.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/42.%20Listados%20Jubilados%20y%20Pensionados"
			
		},
		{
			
			"nombre": "Ingresos Recibidos por Cualquier Concepto",
			"icono":"IngresosRecibidosCualquierConcepto.png",
			"formatos": [
				{
					"nombre": "Ingresos Recibidos",
					"xlsx": "f43_a",
					"html": "f43_a"
				},
				{
					"nombre": "Responsables de Recibir los Ingresos",
					"xlsx": "f43_b",
					"html": "f43_b"
				}
			],
			"url" : "https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/43.Ingresos%20Recibidos%20por%20Cualquier%20Concepto"	
			
		},
		{
			
			"nombre": "Donaciones Hechas a Terceros",
			"icono":"DonacionesHechasTerceros.png",
			"formatos": [
				{
					"nombre": "Donaciones hechas a Terceros en Dineros",
					"xlsx": "f44a",
					"html": "f44a"
				},

			]	
			
		},
		{
			
			"nombre": "Catálogo Documental y Guia de Archivos",
			"icono":"Viaticos.png",
			"formatos": [
				{
					"nombre": "Inventarios Documentales",
					"xlsx": "f45a",
					"html": "f45a"
				},
				{
					"nombre": "Índice de Expedientes Clasificados",
					"xlsx": "f45b",
					"html": "f45b"
					
				},
				
				{
					"nombre": "Instrumentos Archivisticos",
					"xlsx": "f45c",
					"html": "f45c"
				}
			],
			"url" : ""
			
		},
		{
			
			"nombre": "Actas de Sesiones, Opiniones y Recomendaciones de Consejos Consultivos",
			"icono":"CatalogoDocumentalGuiaArchivos.png",
			"formatos": [
				{
					"nombre": "Actas del Consejo Consultivo Ciudadano",
					"xlsx": "f46a",
					"html": "f46a"
				},
				{
					"nombre": "Opiniones del Consejo Consultivo Ciudadano",
					"xlsx": "f46b",
					"html": "f46b"
				}
			],
			"url" : "https://s-turismo.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/46.Actas%20de%20Sesiones,%20Opiniones%20y%20Recomendaciones%20de%20Consejos%20Consultivos"
			
		},
		{
			
			"nombre": "Solicitud de Intervención de Comunicaciones",
			"icono":"SolicitudIntervencionComunicaciones.png",
			"formatos": [
				{
					"nombre": "Intervenciones de comunicaciones",
					"xlsx": "f47a",
					"html": "f47a"
				},
				{
					"nombre": "Localización Geográfica",
					"xlsx": "f47b",
					"html": "f47b"
				},
				{
					"nombre": "Mensaje de Solicitudes a empresas para la intervención de comunicaciones privadas",
					"xlsx": "f47c",
					"html": "f47c"
				}
			],
			"url" : "https://procuraduria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/Solicitud%20de%20Intervenci%C3%B3n%20de%20%20Comunicaciones"
			
		},
		{
			
			"nombre": "Información de Utilidad o Relevante",
			"icono":"InformacionUtilidadRelevante.png",
			"formatos": [
				{
					"nombre": "Interés Público",
					"xlsx": "f48a",
					"html": "f48a"
				},
				{
					"nombre": "Preguntas Frecuentes",
					"xlsx": "f48b",
					"html": "f48b"
				},
				{
					"nombre": "Transparencia Proactiva",
					"xlsx": "f48c",
					"html": "f48c"
				}
			]

			
		},
]